import React from 'react';
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { Component } from './Component/Component.component';
import { Category as CategoryType } from '@Types';
import { useGlobalization } from '@Translations/useGlobalization';

// The unmodified pre-redesign body — the "Category Weighting" slider row
// plus the Name/Weight column header — kept in its own component for the
// same reason as ClassicCategoryHeader: untouched behaviour, and it stops
// contributing to Category's own cognitive complexity.
interface ClassicCategoryBodyProps {
	category?: CategoryType;
	isLoading: boolean;
	isWeightingInvalid: boolean;
	weightingDescription: string;
	columnHeaderClassName: string;
	onCategoryWeightingChanged?: (value: number) => void;
	onUseHighestChange: (checked: boolean) => void;
}

export const ClassicCategoryBody = ({
	category,
	isLoading,
	isWeightingInvalid,
	weightingDescription,
	columnHeaderClassName,
	onCategoryWeightingChanged,
	onUseHighestChange,
}: ClassicCategoryBodyProps) => {
	const { t } = useGlobalization();

	const weightingInvalid =
		(!category?.isCondition && isWeightingInvalid) ||
		Boolean(
			category?.isCondition &&
				!category.useThisOnly &&
				isWeightingInvalid,
		);

	return (
		<>
			{!isLoading && (
				<Component
					title={t('Category Weighting')}
					invalid={weightingInvalid}
					subTitle={weightingDescription}
					value={category ? category.weighting : 0}
					onSliderValueChanged={onCategoryWeightingChanged}
					needMenu={false}
					disableSlider={
						category?.isCondition && category.useThisOnly
					}
					enabledChecked={true}
				/>
			)}
			<Grid
				container
				className={columnHeaderClassName}
				style={{ display: 'flex' }}
				alignItems="center">
				<Grid xs={2} item>
					{t('Name')}
				</Grid>
				<Grid xs={4} item>
					{t(category?.useHighestScore ? 'Enabled' : 'Weight')}
				</Grid>
				{isLoading ? (
					<Grid xs={6} item />
				) : (
					<Grid
						xs={6}
						item
						container
						style={{ justifyContent: 'flex-end' }}>
						<FormControlLabel
							control={
								<Checkbox
									style={{ padding: '0px' }}
									sx={{
										'& .MuiSvgIcon-root': { fontSize: 14 },
									}}
									disabled={category?.weighting === 0}
									checked={category?.useHighestScore}
									onChange={e =>
										onUseHighestChange(e.target.checked)
									}
								/>
							}
							label={
								<Typography
									variant="body2"
									style={{ marginRight: '6px' }}>
									{t(`Use highest score from components as
								overall category score`)}
								</Typography>
							}
							labelPlacement="start"
						/>
					</Grid>
				)}
			</Grid>
		</>
	);
};
